import React, { useState } from "react";
import axios from "axios";
import { Box, Button, TextField, Typography, Paper } from "@mui/material";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [soloAdmin, setSoloAdmin] = useState(true); // <-- Añades el flag aquí

  const handleLogin = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_LOGIN_URL}/auth/login`,
        {
          email,
          password,
          turnos: soloAdmin, // <-- Enviado al backend
        },
      );

      if (response.data.status) {
        // const { token, id_usuario, numeroElementosTablalistado, idTarifaActiva } = response.data;
        const {
          token,
          id,
          rol,
          nombre,
          id_empresa,
          nombreempresa,
          id_empresaSede,
          restoUsuario,
        } = response.data;

        // Guardar token y datos en localStorage
        localStorage.setItem(process.env.REACT_APP_PREFIJO + "token", token);
        localStorage.setItem(process.env.REACT_APP_PREFIJO + "id_usuario", id);
        localStorage.setItem(process.env.REACT_APP_PREFIJO + "rol", rol);
        localStorage.setItem(process.env.REACT_APP_PREFIJO + "nombre", nombre);
        localStorage.setItem(
          process.env.REACT_APP_PREFIJO + "id_empresa",
          id_empresa,
        );
        localStorage.setItem(
          process.env.REACT_APP_PREFIJO + "nombreempresa",
          nombreempresa,
        );
        localStorage.setItem(
          process.env.REACT_APP_PREFIJO + "id_empresaSede",
          id_empresaSede,
        );
        localStorage.setItem(
          process.env.REACT_APP_PREFIJO + "foto",
          "https://api.fichajedigital.com/usuarios/imagenes" +
            restoUsuario.fotoPerfil,
        );

        // Redirige a la página principal
        window.location.href = "/";
      }
    } catch (err) {
      console.log(err);
      alert(err.response.data.message);
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        backgroundColor: "#f5f5f5",
        padding: 0,
        margin: 0,
      }}
    >
      <Paper
        elevation={3}
        sx={{
          padding: 4,
          borderRadius: 2,
          width: "100%",
          maxWidth: 400,
          textAlign: "center",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            marginBottom: 3,
          }}
        >
          <img
            src="./../recursos/logo.png"
            alt="Logo Empresa"
            style={{
              maxWidth: "100%",
              height: "auto",
              maxHeight: 100,
            }}
          />
        </Box>
        <Typography variant="h5" gutterBottom>
          ¡Bienvenido!
        </Typography>
        <Typography variant="body1" gutterBottom>
          Inicia sesión para continuar
        </Typography>
        <Box component="form" onSubmit={handleLogin} noValidate>
          <TextField
            label="Correo Electrónico"
            variant="outlined"
            fullWidth
            margin="normal"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <TextField
            label="Contraseña"
            type="password"
            variant="outlined"
            fullWidth
            margin="normal"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          <Button
            type="submit"
            variant="contained"
            color="primary"
            fullWidth
            size="large"
            sx={{ marginTop: 2 }}
          >
            Acceder
          </Button>
        </Box>
      </Paper>
    </Box>
  );
};

export default Login;
